import React, { useRef, useState } from 'react';
import {
  Container,
  ContentLayer,
  DotsBackground,
  GradientBlob,
  StyledUploadButton,
  UploadBoxLabel,
  UploadBoxSubLabel,
} from './styles';

import Spinner from '@/components/@IntranetLibrary/Spinner';
import UploadIcon from '@/public/icons/upload.svg';

type P = {
  uploading: boolean;
  handleCancel: () => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDrop: (e: React.DragEvent<HTMLDivElement>) => void;
};

const CustomUpload = ({
  uploading,
  handleCancel,
  handleInputChange,
  handleDrop,
}: P) => {
  const [isDotsHovered, setIsDotsHovered] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <Container
      onMouseEnter={() => setIsDotsHovered(true)}
      onMouseLeave={() => setIsDotsHovered(false)}
      onDrop={handleDrop}
      onDragOver={(e) => e.preventDefault()}
      uploading={uploading}
    >
      <ContentLayer uploading={uploading}>
        {uploading ? (
          <UploadBoxSubLabel style={{ color: '#C77AC4' }}>
            필요한 정보가 모두 포함되어 있는지 AI가 검토중이에요.
          </UploadBoxSubLabel>
        ) : (
          <>
            <UploadBoxLabel>
              파일을 이곳에 끌어다 놓거나 아래 버튼을 눌러 추가해 주세요.
            </UploadBoxLabel>
            <UploadBoxSubLabel>
              최대 500MB / Image, PDF만 가능
            </UploadBoxSubLabel>
          </>
        )}
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*,application/pdf"
          style={{ display: 'none' }}
          onChange={handleInputChange}
        />
        <StyledUploadButton
          onClick={() =>
            uploading ? handleCancel() : fileInputRef.current?.click()
          }
          uploading={uploading}
        >
          {uploading ? (
            <Spinner theme={'ai'} size={'20px'} className={'ai-spinner'} />
          ) : (
            <UploadIcon />
          )}
          {uploading ? '검토 취소' : '파일 업로드'}
        </StyledUploadButton>
      </ContentLayer>
      <GradientBlob
        width="75%"
        bottom="30px"
        left="50%"
        transform="translateX(-50%)"
      />
      <GradientBlob bottom="-124px" left="360px" />
      <GradientBlob bottom="-124px" right="360px" />
      <DotsBackground isHovered={isDotsHovered} />
    </Container>
  );
};

export default CustomUpload;
